import FormControl from '@material-ui/core/FormControl';
import Grid from '@material-ui/core/Grid';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import { makeStyles } from '@material-ui/core/styles';
import React, { ChangeEvent, FunctionComponent } from 'react';
import { useOrdersContext } from '../../contexts/OrdersContext';

const useStyles = makeStyles((theme) => ({
  formControl: {
    minWidth: '90%',
    margin: theme.spacing(1),
    marginTop: theme.spacing(2),
    [theme.breakpoints.down(768)]: {
      minHeight: '20px',
      minWidth: '90%',
    },
    [`${theme.breakpoints.down(920)} and (orientation: landscape)`]: {
      minHeight: '20px',
      minWidth: '90%',
    },
  },
  label: {
    backgroundColor: 'white',
    [theme.breakpoints.down(768)]: {
      fontSize: 13,
    },
    [`${theme.breakpoints.down(920)} and (orientation: landscape)`]: {
      fontSize: 13,
      left: 8,
    },
  },
  select: {
    minWidth: '280px',
    fontSize: '15px',
    [theme.breakpoints.down(768)]: {
      fontSize: '12px',
      height: '40px',
      minWidth: '100%',
    },
    [`${theme.breakpoints.down(920)} and (orientation: landscape)`]: {
      fontSize: '12px',
      height: '40px',
      minWidth: '100%',
    },
  },
  menuPaper: {
    maxHeight: 300,
    fontSize: '18px',
    [theme.breakpoints.down(768)]: {
      fontSize: '12px',
      margin: theme.spacing(0),
    },
    [`${theme.breakpoints.down(920)} and (orientation: landscape)`]: {
      fontSize: '12px',
      margin: theme.spacing(0),
    },
  },
}));

const MobileOrderTypeFilter: FunctionComponent = () => {
  const { orderTypes, orderType, setOrderType } = useOrdersContext();
  const classes = useStyles();

  const handleOrderTypeChange = (event: ChangeEvent<{ value: unknown }>): void => {
    setOrderType(event.target.value as number);
  };

  return (
    <Grid item sm={4} xs={12}>
      <FormControl variant="outlined" className={classes.formControl}>
        <InputLabel id="mall-label" className={classes.label}>
          Order Type
        </InputLabel>
        <Select
          label="Choose Mall"
          labelId="mall-select-label"
          id="mall-select"
          value={orderType}
          onChange={handleOrderTypeChange}
          MenuProps={{
            classes: { paper: classes.menuPaper },
            anchorOrigin: {
              vertical: 'bottom',
              horizontal: 'left',
            },
            getContentAnchorEl: null,
          }}
          className={classes.select}
        >
          {orderTypes.map((o) => (
            <MenuItem key={o.id} value={o.id}>
              {o.name}
            </MenuItem>
          ))}
        </Select>
      </FormControl>
    </Grid>
  );
};

export default MobileOrderTypeFilter;
